import home from './src/home.vue'
import WeatherHome from './src/WeatherHome.vue'
import Ecologicaldata from './src/Ecologicaldata.vue'
import WeathersHome from './src/WeathersHome.vue'

let views = {
    home,
    WeatherHome,
    Ecologicaldata,
    WeathersHome
};

export default views;